const API_BASE = '/api';
export const api = {
  login: async (walletAddress: string, password: string) => {
    const response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ wallet_address: walletAddress, password })
    });
    return response.json();
  },
  setupCredentials: async (data: any) => {
    const response = await fetch(`${API_BASE}/credentials/setup`, {
      method: 'POST', 
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return response.json();
  },
  getTradingStatus: async (userId: string) => {
    const response = await fetch(`${API_BASE}/trading/status`, {
      headers: { "X-User-ID": userId }
    });
    return response.json();
  },
  getLivePosition: async (symbol: string, userId: string) => {
    const response = await fetch(`${API_BASE}/v2/live/position/${symbol}`, { headers: { "X-User-ID": userId } });
    return response.json();
  },
  getLivePnl: async (symbol: string, userId: string) => {
    const response = await fetch(`${API_BASE}/v2/live/pnl/${symbol}`, { headers: { "X-User-ID": userId } });
    return response.json();
  },
  getLiveMomentum: async (userId: string) => {
    const response = await fetch(`${API_BASE}/v2/live/momentum`, { headers: { "X-User-ID": userId } });
    return response.json();
  },
  getChopIndicator: async (symbol: string, userId: string) => {
    const response = await fetch(`${API_BASE}/v2/live/chop/${symbol}`, { headers: { "X-User-ID": userId } });
    return response.json();
  }
};
